import xss from 'xss'

// Tab component
class TabComponent extends HTMLElement {
  iframes: unknown[] = []

  connectedCallback() {
    this.hideAll()

    const tab = this.querySelector('tab-inner')
    if (tab) {
      const hashIdx = this.checkHash()
      if (hashIdx) {
        this.show(hashIdx)
      } else {
        this.show(tab.getAttribute('id') ?? '')
      }
    }

    this.addEventListener('click', e => {
      const target = e.target as HTMLElement
      let idx: string | null | undefined
      if (target.classList.contains('Button-icon')) {
        idx =
          target.parentNode &&
          (target.parentNode as HTMLElement).getAttribute('aria-controls')
      } else {
        idx = target.getAttribute('aria-controls')
      }
      if (!idx) {
        return
      }

      e.preventDefault()
      this.hideAll()
      this.show(idx)
    })

    this.wrapContent()
  }

  wrapContent() {
    this.querySelectorAll('tab-inner').forEach(tab => {
      const blocks = tab.querySelectorAll('.content-block')
      const tabContent = tab.querySelector('.Tab-content')
      if (!tabContent) return
      const container = tabContent.classList

      if (container.contains('img-right') || container.contains('img-left')) {
        blocks.forEach(block => {
          const images = block.querySelectorAll('img')
          images.forEach(image => {
            if (image) {
              image.classList.add('u-sizeFull')

              // Wrap content
              const wrapper = document.createElement('div')
              wrapper.innerHTML = xss(block.innerHTML)
              block.innerHTML = ''
              block.className += ' has-image u-flex u-sm-flexCol'
              wrapper.className =
                'Tab-text u-md-size2of3 u-lg-size2of3 u-paddingVert8'
              if (container.contains('img-left')) {
                wrapper.classList.add('u-flexOrderLast')
              }
              const child = wrapper.querySelector('img')
              if (child?.parentNode) {
                child.parentNode.removeChild(child)
              }
              block.appendChild(wrapper)

              // Wrap images
              const figure = document.createElement('div')
              figure.className =
                'Tab-image u-sm-sizeFull u-md-size1of3 u-lg-size1of3'
              if (container.contains('img-left')) {
                figure.classList.add('u-marginRight20')
                figure.classList.add('u-sm-marginRight0')
              }
              if (container.contains('img-right')) {
                figure.classList.add('u-marginLeft20')
                figure.classList.add('u-sm-marginLeft0')
              }
              images.forEach(img => figure.appendChild(img))
              block.appendChild(figure)
            }
          })
        })
      }
    })
  }

  checkHash(): string | undefined {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1)
      const button = this.querySelector(`button[id="${hash}"]`)
      if (button && button.hasAttribute('tab-idx')) {
        return button.getAttribute('tab-idx') ?? undefined
      }
    }
    return undefined
  }

  hideAll() {
    if (document.querySelector('.Tabs.vertical')) {
      this.querySelectorAll('[role="tab"]').forEach(button => {
        button.setAttribute('aria-selected', 'false')
        button.classList.remove('u-textColorBrandLight')
        button.classList.add('u-textColorDefault')
      })
    } else {
      this.querySelectorAll('[role="tab"]').forEach(button => {
        button.setAttribute('aria-selected', 'false')
        button.classList.remove('Item-active')
        button.classList.remove('u-textColorBrandLight')
        button.classList.add('u-textColorDefault')
      })
    }

    this.querySelectorAll('tab-inner').forEach(tab => {
      const tabEl = tab as HTMLElement
      tabEl.hidden = true
      tab.setAttribute('aria-expanded', 'false')
    })
  }

  show(idx: string) {
    const selector = `tab-inner[id="${idx}"] , tab-inner[id="${idx.replace(
      /-a$/,
      '-b'
    )}"]`
    const tabs = this.querySelectorAll(selector)
    const button = this.querySelector(`button[aria-controls="${idx}"]`)

    if (!button) return

    if (document.querySelector('.Tabs.vertical')) {
      button.classList.remove('u-textColorDefault')
      button.classList.add('u-textColorBrandLight')
    } else {
      button.classList.remove('u-textColorDefault')
      button.classList.add('Item-active')
      button.classList.add('u-textColorBrandLight')
    }
    button.setAttribute('aria-selected', 'true')

    tabs.forEach(tab => {
      const tabEl = tab as HTMLElement
      tabEl.hidden = false
      tab.setAttribute('aria-expanded', 'true')
    })
  }
}
customElements.define('tab-component', TabComponent)
